import {
    trackClickInteraction,
    trackClickInteractionWithoutContext,
} from "../trackers/genericClickTracker";
import { hasTrackingEventSuffix } from "../trackers/utils";

interface InteractionEvent {
    target: InteractionElement;
}

interface InteractionElement {
    closest(selector: string): HTMLElement;
}

const isValidInteractionTarget = (event: InteractionEvent) => {
    return event.target && typeof event.target.closest === "function";
};

const getWrappingTrackingElement = (e: InteractionEvent): HTMLElement => {
    return e.target.closest("[data-tracking-event]");
};

const trackGenericClickInteractions = (): void => {
    document.addEventListener(
        "click",
        (e: any): void => {
            if (isValidInteractionTarget(e)) {
                const element = getWrappingTrackingElement(e);
                const possibleAnchorElement = e.target.closest("a") || e.target;
                const isAnchorTag = possibleAnchorElement.tagName === "A";
                if (element && hasTrackingEventSuffix(element, "-click")) {
                    trackClickInteraction(
                        element,
                        isAnchorTag
                            ? (possibleAnchorElement as HTMLAnchorElement)
                            : undefined,
                    );
                } else {
                    if (isAnchorTag) {
                        trackClickInteractionWithoutContext(
                            possibleAnchorElement as HTMLAnchorElement,
                        );
                    }
                }
            }
        },
        false,
    );
};

export { trackGenericClickInteractions };
